const TRANSITION_MS = 280;
const STAGGER_MS = 60;

const applyFilter = (items, emptyMsg, category) => {
    const toHide = [];
    const toShow = [];

    items.forEach(item => {
        const article = item.querySelector('article');
        const itemCategories = article?.dataset.category?.split(',') ?? [];

        if (category === 'all' || itemCategories.includes(category)) {
            toShow.push(item);
        } else {
            toHide.push(item);
        }
    });

    items.forEach(item => clearTimeout(item._filterTimer));

    // Phase 1: fade out all currently visible items at once so the layout
    // never reflows while something is still visible
    items
        .filter(item => !item.classList.contains('is-hidden'))
        .forEach(item => {
            item.style.transitionDelay = '';
            item.classList.add('is-out');
        });

    setTimeout(() => {
        // Collapse hidden items — layout reflows here but everything is already transparent
        toHide.forEach(item => {
            item.classList.add('is-hidden');
            item.classList.remove('is-out');
        });

        // Bring matching items into the DOM and ensure they start in the out-state
        toShow.forEach(item => {
            item.classList.remove('is-hidden');
            item.classList.add('is-out');
        });

        // Single reflow to commit all state changes before animating
        if (toShow.length > 0) toShow[0].offsetHeight;

        // Stagger fade-in
        toShow.forEach((item, i) => {
            item.style.transitionDelay = `${i * STAGGER_MS}ms`;
            item.classList.remove('is-out');
            item._filterTimer = setTimeout(() => {
                item.style.transitionDelay = '';
            }, i * STAGGER_MS + TRANSITION_MS);
        });

        if (emptyMsg) emptyMsg.hidden = toShow.length > 0;
    }, TRANSITION_MS);
};

export const initCategoryFilter = () =>
{
    document.querySelectorAll('.categories').forEach(categories =>
    {
        const filters = categories.querySelectorAll('button[data-filter]');
        const items = [...categories.closest('.content-block').querySelectorAll('ul[data-filtered] li')];
        const emptyMsg = categories.closest('.content-block').querySelector('[data-empty-message]');

        filters.forEach(filter =>
        {
            filter.addEventListener('click', (e) =>
            {
                e.preventDefault();

                filters.forEach(f =>
                {
                    f.classList.remove('active');
                    f.setAttribute('aria-pressed', 'false');
                });
                filter.classList.add('active');
                filter.setAttribute('aria-pressed', 'true');

                applyFilter(items, emptyMsg, filter.dataset.filter);
            })
        });
    });
    // document.querySelectorAll('[data-type="jobs"]').forEach(block =>
    // {
    //     const nav = block.querySelector('nav.categories');
    //
    //     if (!nav) return;
    //
    //     const filters = nav.querySelectorAll('a');
    //     const items = [...block.querySelectorAll('ul.jobs li')];
    //     const emptyMsg = block.querySelector('.jobs-empty');
    //
    //     filters.forEach(filter =>
    //     {
    //         filter.addEventListener('click', (e) =>
    //         {
    //             e.preventDefault();
    //
    //             filters.forEach(f => f.classList.remove('active'));
    //             filter.classList.add('active');
    //
    //             applyFilter(items, emptyMsg, filter.getAttribute('href').slice(1));
    //         });
    //     });
    // });
};
